import React from "react";
import { useRequest } from "../../utils";
import styles from "../getOrders/OrdersPanel.module.css";

/**
 * Shopping-list submissions — visual alignment with GetQuotes.
 * Preserves GET /get_shoping_list fields and file link. No quote workflow.
 * (Isolated workspace copy — not deployed.)
 */
const GetShopingList = () => {
  const [products_error, products_loading, products_data, products_function] =
    useRequest({
      method: "get",
      url: "/get_shoping_list",
    });

  const rows = products_data?.data || [];

  return (
    <div className={styles.root}>
      <div className={styles.pageHead}>
        <div className={styles.titleBlock}>
          <h1>لیست خرید</h1>
          <p className={styles.subtitle}>
            درخواست‌های ارسال‌شده از فرم لیست خرید فروشگاه
          </p>
        </div>
        <div className={styles.toolbar}>
          <button
            type="button"
            className={styles.btnGhost}
            onClick={() => products_function().then(() => null)}
          >
            بروزرسانی
          </button>
        </div>
      </div>

      {products_error ? (
        <div className={styles.empty}>بارگذاری لیست خرید ناموفق بود.</div>
      ) : null}
      {products_loading && !products_data ? (
        <div className={styles.empty}>در حال بارگذاری…</div>
      ) : null}

      {products_data ? (
        <div className={styles.tableCard}>
          <div style={{ padding: "12px 14px", fontWeight: 700, color: "#1f355e" }}>
            تعداد ثبت‌ها: {rows.length}
          </div>
          {rows.length === 0 ? (
            <div className={styles.empty}>موردی ثبت نشده است.</div>
          ) : (
            <>
              <div className={styles.tableWrap}>
                <table className={styles.table}>
                  <thead>
                    <tr>
                      <th>نام</th>
                      <th>شماره تلفن</th>
                      <th>نوع پروژه</th>
                      <th>توضیحات بیشتر</th>
                      <th>فایل</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((item) => (
                      <tr key={String(item._id)}>
                        <td className={styles.refCell}>{item.name || "—"}</td>
                        <td dir="ltr" style={{ textAlign: "right" }}>
                          {item.phone_number || "—"}
                        </td>
                        <td>{item.project_type || "—"}</td>
                        <td>
                          <div className={styles.notesBlock} style={{ margin: 0, padding: 8 }}>
                            {item.more_details || "—"}
                          </div>
                        </td>
                        <td>
                          {item.file?.name ? (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={"https://files.pipeup.ir/" + item.file.name}
                            >
                              <button type="button" className={styles.btnDetail}>
                                مشاهده فایل
                              </button>
                            </a>
                          ) : (
                            "—"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className={styles.mobileCards}>
                {rows.map((item) => (
                  <div className={styles.mobileCard} key={`m-${item._id}`}>
                    <div className={styles.refCell}>{item.name || "—"}</div>
                    <div className={styles.mobileRow}>
                      <span>تلفن</span>
                      <span dir="ltr">{item.phone_number || "—"}</span>
                    </div>
                    <div className={styles.mobileRow}>
                      <span>نوع پروژه</span>
                      <span>{item.project_type || "—"}</span>
                    </div>
                    <div style={{ marginTop: 8, fontSize: 14, lineHeight: 1.7 }}>
                      {item.more_details || "—"}
                    </div>
                    {item.file?.name ? (
                      <div style={{ marginTop: 10 }}>
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={"https://files.pipeup.ir/" + item.file.name}
                        >
                          <button type="button" className={styles.btnDetail}>
                            مشاهده فایل
                          </button>
                        </a>
                      </div>
                    ) : null}
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      ) : null}
    </div>
  );
};

export { GetShopingList };
